import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import { HomeComponent } from './';

export const HOME_ROUTE: Route = {
    path: '',
    component: HomeComponent,
    data: {
        authorities: [],
        pageTitle: 'home.browserTitle'
    },
    canActivate: [
        UserRouteAccessService
    ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.route.ts